var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.3346C8 15.3346 14 11.3346 14 6.66797C14 5.07667 13.3679 3.55055 12.2426 2.42533C11.1174 1.30011 9.5913 0.667969 8 0.667969C6.4087 0.667969 4.88258 1.30011 3.75736 2.42533C2.63214 3.55055 2 5.07667 2 6.66797C2 11.3346 8 15.3346 8 15.3346Z",
    stroke: "#121865",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.3346C8 15.3346 14 11.3346 14 6.66797C14 5.07667 13.3679 3.55055 12.2426 2.42533C11.1174 1.30011 9.5913 0.667969 8 0.667969C6.4087 0.667969 4.88258 1.30011 3.75736 2.42533C2.63214 3.55055 2 5.07667 2 6.66797C2 11.3346 8 15.3346 8 15.3346Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.66797C9.10457 8.66797 10 7.77254 10 6.66797C10 5.5634 9.10457 4.66797 8 4.66797C6.89543 4.66797 6 5.5634 6 6.66797C6 7.77254 6.89543 8.66797 8 8.66797Z",
    stroke: "#121865",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.66797C9.10457 8.66797 10 7.77254 10 6.66797C10 5.5634 9.10457 4.66797 8 4.66797C6.89543 4.66797 6 5.5634 6 6.66797C6 7.77254 6.89543 8.66797 8 8.66797Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.ac8f6bf0613ab2bbfbe194dd72f9a7f1.svg";
export { ForwardRef as ReactComponent };